if (!customElements.get("m-scrolling-promotion")) {
  class MScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      this._resizeTimer = null;
      this._observer = null;
    }

    connectedCallback() {
      this.promotion = this.querySelector(".m-promotion");

      // Hide immediately before any paint to prevent flicker
      this.style.visibility = "hidden";

      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.init());
      });
    }

    init() {
      if (!this.promotion) return;
      if (this.childElementCount !== 1) return;

      // Add animation class to original element
      this.promotion.classList.add("m-promotion--animated");

      // Calculate exact number of clones needed to fill viewport seamlessly
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const itemWidth =
        this.promotion.getBoundingClientRect().width ||
        this.promotion.scrollWidth ||
        600; // safe fallback for edge cases

      const clonesNeeded =
        itemWidth > 0
          ? Math.ceil((viewportWidth * 3) / itemWidth) + 2
          : 10;

      // Use DocumentFragment for single DOM operation - avoids multiple reflows
      const fragment = document.createDocumentFragment();
      for (let i = 0; i < clonesNeeded; i++) {
        const clone = this.promotion.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.querySelectorAll('a').forEach(a => a.setAttribute('tabindex', '-1'));
        fragment.appendChild(clone);
      }

      // Append all clones in one operation
      this.appendChild(fragment);

      // Mark as ready for CSS hook
      this.setAttribute("data-ready", "true");

      // Reveal only after clones are in DOM and browser has painted
      requestAnimationFrame(() => {
        this.style.visibility = "";
      });

      // Pause animation when scrolled out of view to save resources
      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.isIntersecting
              ? this.scrollingPlay()
              : this.scrollingPause();
          });
        },
        { rootMargin: "0px 0px 50px 0px" }
      );
      this._observer.observe(this);

      // Handle window resize and orientation change
      window.addEventListener("resize", this._onResize.bind(this));
    }

    _onResize() {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => {
        // Hide during reinit to prevent flicker on resize
        this.style.visibility = "hidden";
        this.removeAttribute("data-ready");

        // Remove all clones
        this.querySelectorAll('[aria-hidden="true"]').forEach((el) =>
          el.remove()
        );

        // Reset original element
        this.promotion.classList.remove("m-promotion--animated");

        // Disconnect old observer
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }

        // Reinitialize after layout settles
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.init());
        });
      }, 300);
    }

    scrollingPlay() {
      this.classList.remove("m-scrolling-promotion--paused");
    }

    scrollingPause() {
      this.classList.add("m-scrolling-promotion--paused");
    }
  }

  customElements.define("m-scrolling-promotion", MScrollingPromotion);
}